export default function Microphone({ className = "" }) {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      viewBox="0 0 48 48"
      className={className}>
      <path d="M24 32.8c4.4 0 7.9-3.6 7.9-7.9v-17C31.9 3.6 28.4 0 24 0s-7.9 3.6-7.9 7.9v16.9c0 4.4 3.5 8 7.9 8zM19.1 7.9C19.1 5.2 21.3 3 24 3s4.9 2.2 4.9 4.9v16.9c0 2.7-2.2 4.9-4.9 4.9s-4.9-2.2-4.9-4.9V7.9z" />
      <path d="M36 19.1c-.8 0-1.5.7-1.5 1.5v4.8c0 5.8-4.7 10.5-10.5 10.5s-10.5-4.7-10.5-10.5v-4.8c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5v4.8c0 6.9 5.3 12.7 12 13.4v7.7c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5v-7.7c6.7-.7 12-6.5 12-13.4v-4.8c0-.8-.7-1.5-1.5-1.5z" />
    </svg>
  )
}
